import { render, staticRenderFns } from "./Metricas.vue?vue&type=template&id=5a3fa95a&scoped=true"
import script from "./Metricas.vue?vue&type=script&lang=js"
export * from "./Metricas.vue?vue&type=script&lang=js"
import style0 from "./Metricas.vue?vue&type=style&index=0&id=5a3fa95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3fa95a",
  null
  
)

export default component.exports